import { Alert, Anchor, Text } from "@mantine/core";
import CustomDrawer from "../drawer";
import Rules from "../rules";
import { useDisclosure } from "@mantine/hooks";

function SendingMessageRules() {
  const [preview, { open, close }] = useDisclosure(false);
  return (
    <>
      <Alert color="yellow">
        <Text size="xs">
          با توجه به قوانین ارسال پیام در اپراتورهای مخابراتی تنها بین ساعات
          <Text fw="800" span>
            {" "}
            10 صبح
          </Text>{" "}
          تا{" "}
          <Text fw="800" span>
            {" "}
            20 عصر
          </Text>{" "}
          پیام های شما ارسال میگردد.{" "}
          <Anchor onClick={open}>
            <Text td="underline" span>
              مشاهده قوانین کامل ارسال پیامک
            </Text>
          </Anchor>
        </Text>
      </Alert>
      <CustomDrawer
        opened={preview}
        onClose={close}
        close={close}
        position="bottom"
        radius="xl"
        custom="sending-message-rules"
        title="قوانین ارسال پیامک"
      >
        <Rules />
      </CustomDrawer>
    </>
  );
}

export default SendingMessageRules;
